import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { UIRouter }                                      from '@uirouter/core';
import { TranslateService }                              from '@ngx-translate/core';

import { ApiService }    from '../../app-lite/api/api.service';
import { TableService }  from '../../app-lite/table/table.service';

import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

@Component({
  selector   : 'customer-billed',
  template: require('./customer.billed.html')
})
export class CustomerBilledComponent implements OnInit {
  @Input() customer: any;
  @Input() customers: any[];

  columns: any[];
  showBillerCustomers: boolean;
  tableCacheKey: string;
  tableSettings: any;

  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService,
    @Inject(forwardRef(() => TableService)) private tableService: TableService,
    private router: UIRouter,
    private translateService: TranslateService
  ) {}

  ngOnInit () {
    this.showBillerCustomers = !!this.customers.length;
    this.tableCacheKey       = 'billedCustomers';

    this.columns = [
      {
        field : 'display_name',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.COMPANY')
        },
        classes: 'all-caps'
      },
      {
        field : 'phone',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.PHONE')
        }
      },
      {
        field : 'email',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: (event) => this.viewCustomer(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ];

    this.tableSettings = {
      cache: {
        enabled: true,
        key    : this.tableCacheKey
      },
      columns: this.columns,
      empty  : {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_CUSTOMERS_FOUND')
      },
      pagination: {
        enabled   : true,
        pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 5,
        pageSizes : [ 5, 10, 25, 50 ],
        queryCount: () => this.apiService.get('/customers/biller_child_count', this.customer.id)
      },
      rows: {
        highlight: {
          enabled: true
        }
      },
      sorting: {
        enabled: false
      },
    };
  }

  getCustomers ( params ): Promise<any> {
    return this.apiService.get('/customers/biller_child_list', [
      this.customer.id,
      params.offset,
      params.pageSize,
    ]).then((customers) => {
      this.customers = customers;

      return customers;
    });
  }

  onRowDoubleClick ( event: any ): void {
    this.viewCustomer(event.row);
  }

  viewCustomer ( customer: any ): void {
    this.router.stateService.go('app.customer', {
      id: customer.id
    });
  }
}
